import { platform } from 'utils/platform';

export interface Platform {
  OS: string | undefined;
  isIOS: boolean;
  isAndroid: boolean;
}

export default function usePlatform(): Platform {
  return platform();
}
